"use client";

import { Link } from "@/i18n/navigation";
import clsx from "clsx";

/**
 * CommonListItemCard
 * Basit, jenerik bir liste kartı.
 * Sadece verilen item içinden label ve href üretir,
 * domain'e özel (flight, bus vb.) hiçbir metin içermez.
 */
export default function CommonListItemCard({ item, className = "" }) {
  if (!item) return null;

  const label = item.Label || item.Title || item.Name || "";
  const href = item.RedirectUrl || item.href || "/";

  if (!label) return null;

  return (
    <Link
      className={clsx(
        "cursor-pointer text-base font-medium text-gray-900 lg:text-lg",
        className,
      )}
      href={href}
    >
      {label}
    </Link>
  );
}


